import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Subject, map } from 'rxjs';
import { FormGroupModel } from 'src/app/components/form-group/form-group.types';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {
  readonly #http = inject(HttpClient);

  readonly #touchedSubject = new Subject<void>();

  readonly keys: string[] = [];

  get(id: string) {
    return this.#http.get<FormGroupModel>(`api/form-group/${id}`)
      .pipe(
        map(res => {
            res.sections.push({
              title: 'お客様の情報を入力してください',
              description: null,
              items: [
                {
                  key: 'name',
                  type: 'name',
                  name: 'お名前'
                },
                {
                  key: 'nameKana',
                  type: 'name',
                  name: 'お名前（ふりがな）'
                },
                {
                  key: 'phoneNumber',
                  type: 'tel',
                  name: '電話番号'
                },
                {
                  key: 'email',
                  type: 'input',
                  name: 'メールアドレス'
                }
              ]
            });
            return res;
          })
        );
  }

  get touched$() {
    return this.#touchedSubject.asObservable();
  }
  markAsTouched() {
    this.#touchedSubject.next();
  }

  answer(id: string, data: unknown) {
    return this.#http.post(`api/form-group/${id}`, data);
  }
}
